import React from 'react';
import './index.css';
import airportDropoff from './Pictures/airportdropoff.png';  // Add your images
import airportPickup from './Pictures/airportpickup.png';    // Add your images
import pointToPoint from './Pictures/pointtopoint.png';     // Add your images
import hourly from './Pictures/hourly.png';                   // Add your images

function Services() {
  return (
    <div className="p-6 text-left px-4 md:px-32"> {/* Increased horizontal padding */}
      <h2 className="text-3xl font-extrabold mb-6 text-center">Services</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 px-4 md:px-24"> {/* Adjusted gap and padding, changed justify-between to justify-center */}
        <div className="flex flex-col items-center">
          <img src={airportDropoff} alt="Airport Drop Off Service" loading="lazy" className="w-68 h-48 object-cover rounded-lg mb-4" />
          <span className="text-lg font-semibold">Airport Drop Off</span>
        </div>
        <div className="flex flex-col items-center">
          <img src={airportPickup} alt="Airport Pickup Service" loading="lazy" className="w-68 h-48 object-cover rounded-lg mb-4" />
          <span className="text-lg font-semibold">Airport Pickup</span>
        </div>
        <div className="flex flex-col items-center">
          <img src={pointToPoint} alt="Point to Point Service" loading="lazy" className="w-68 h-48 object-cover rounded-lg mb-4" />
          <span className="text-lg font-semibold">Point to Point</span>
        </div>
        <div className="flex flex-col items-center">
          <img src={hourly} alt="Hourly as Directed Service" loading="lazy" className="w-68 h-48 object-cover rounded-lg mb-4" />
          <span className="text-lg font-semibold">Hourly as Directed</span>
        </div>
      </div>
    </div>
  );
}

export default Services;